import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoBaseFormControlComponent } from '../eo-base-form-control/eo-base-form-control.component';
import { InputType } from '../eo-input/eo-input.model';
import { EoRadioButtonConfig } from './eo-radiobutton.model';

@Component({
  selector: 'eo-radiobutton',
  templateUrl: './eo-radiobutton.component.html',
  styleUrl: './eo-radiobutton.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoRadiobuttonComponent),
      multi: true,
    },
  ],
})
export class EoRadiobuttonComponent extends EoBaseFormControlComponent {
  protected override _config?: EoRadioButtonConfig;
  override get config(): EoRadioButtonConfig | undefined {
    return this._config;
  }
  override set config(val: EoRadioButtonConfig | undefined) {
    this._config = val;
  }

  @Input() type?: InputType;
  @Input() value?: any;
  @Input() disabled?: boolean;
  @Input() radioButtonStyleClass?: string;

  protected getType(): string {
    return this.type ?? this.config?.type ?? 'radioButton';
  }

  protected getValue(): any {
    return this.config?.value ?? this.value ?? '';
  }

  protected getDisabled(): boolean {
    if (this.disabled !== undefined) {
      return this.disabled;
    }

    return this.config?.disabled ?? false;
  }
}
